import web3 from '../web3'
import SupplyChainLogic from '../contracts/SupplyChainLogic.json'
import SupplyChainProxy from '../contracts/SupplyChainProxy.json'

const load_contract = async () => {
  const id = await web3.eth.net.getId()
  const proxy_network = SupplyChainProxy.networks[id]
  const logic_contract = new web3.eth.Contract(
    SupplyChainLogic.abi,
    proxy_network.address
  )

  return new Promise((resolve, reject) => {
    try {
      const proxy = new web3.eth.Contract(
        SupplyChainProxy.abi,
        proxy_network.address
      )

      var arr = {
        Proxy: proxy,
        Implementation: logic_contract
      }

      resolve(arr)
    } catch (error) {
      reject(error)
    }
  })
}

export { load_contract }
